// src/authConfig.js

// Determine environment
const hostname = window.location.hostname;
const isAzureStaticApps = hostname.endsWith('azurestaticapps.net');
const isStaging = isAzureStaticApps && hostname.includes('-staging.');
const isProduction =
  (hostname === 'imagagrant.com' || hostname === 'www.imagagrant.com') ||
  (isAzureStaticApps && !isStaging && hostname.includes('green-desert-06107ed1e'));
const isDev = isAzureStaticApps && !isProduction && !isStaging;

// Production Entra credentials
const PROD_CONFIG = {
  clientId: "40363ad4-0532-4778-9ae4-d13b3a4183a4",
  authority: "https://grantwriterchatexternal.ciamlogin.com/18ff9104-3943-45c0-937e-ded53d89adff",
  apiScope: "api://40363ad4-0532-4778-9ae4-d13b3a4183a4/access_as_user"
};

// Dev Entra credentials
const DEV_CONFIG = {
  clientId: "7674ad2a-3e5f-4108-bec2-87c8bc55e0bf",
  authority: "https://grantwriterchatexternal.ciamlogin.com/18ff9104-3943-45c0-937e-ded53d89adff",
  apiScope: "api://7674ad2a-3e5f-4108-bec2-87c8bc55e0bf/access_as_user"
};

// Select config based on environment
// Staging should behave like production for auth (same CIAM app registration),
// but we keep an explicit staging flag to avoid misrouting other configs.
const currentConfig = (isProduction || isStaging) ? PROD_CONFIG : DEV_CONFIG;

const getRedirectUri = () => window.location.origin + "/redirect";
const getSilentRedirectUri = () => window.location.origin + "/blank.html";

console.log("[AuthConfig] Environment=", isStaging ? "Staging" : isProduction ? "Production" : isDev ? "Development" : "Local", " Hostname=", hostname, " ClientId=", currentConfig.clientId);

export const msalConfig = {
  auth: {
    clientId: currentConfig.clientId,
    authority: currentConfig.authority,
    knownAuthorities: ["grantwriterchatexternal.ciamlogin.com"],
    redirectUri: getRedirectUri(),
    postLogoutRedirectUri: window.location.origin + "/logout",
    navigateToLoginRequestUrl: false  // Stay at /redirect after OAuth; AuthCallbackHandler handles all routing
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false
  },
  system: {
    allowNativeBroker: false,
    windowHashTimeout: 60000,
    iframeHashTimeout: 15000,
    loadFrameTimeout: 0,
    navigateFrameWait: 0,
    allowRedirectInIframe: false,
    loggerOptions: {
      logLevel: 2, // 0=Verbose, 1=Info, 2=Warning, 3=Error - set to Warning to reduce noise
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case "Error": return console.error(message);
          case "Info": return console.info(message);
          case "Verbose": return console.debug(message);
          case "Warning": return console.warn(message);
          default: return console.log(message);
        }
      }
    }
  }
};

// Export API scope for use in token requests
export const API_SCOPE = currentConfig.apiScope;
export const SILENT_REDIRECT_URI = getSilentRedirectUri();

// Request scopes for login
export const loginRequest = {
  scopes: ["openid", "profile", "offline_access", currentConfig.apiScope],
  // With tenant ID in authority URL, this should still show app name
  domainHint: undefined // Ensure no domain hint is passed
};